import { createFileRoute } from '@tanstack/react-router';
import GeneralTab from '../../../../../../components/account-management/settings/general-tab/GeneralTab';
import Loader from '../../../../../../components/shared/custom-components/Loader';

function AppSettingsGeneralTab() {
  return <GeneralTab />;
}

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/settings/general',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: AppSettingsGeneralTab,
});
